import React from "react"
import { DevicePhoneMobileIcon } from "@heroicons/react/24/outline"

/**
 * Platform icon components
 */

const IOSIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"/>
  </svg>
)

const AndroidIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="-147 -70 294 345" fill="currentColor">
    <g>
      <ellipse cy="41" rx="91" ry="84"/>
      <rect rx="22" height="182" width="182" y="20" x="-91"/>
      <rect rx="6.5" transform="rotate(29)" height="86" width="13" y="-86" x="14"/>
      <rect rx="6.5" transform="rotate(-29)" height="86" width="13" y="-86" x="-27"/>
      <rect rx="24" height="133" width="48" y="41" x="-143"/>
      <rect rx="24" height="133" width="48" y="41" x="95"/>
      <circle cx="-42" cy="-25" r="4" fill="white"/>
      <circle cx="42" cy="-25" r="4" fill="white"/>
    </g>
  </svg>
)

const WindowsIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M3,12V6.75L9,5.43V11.91L3,12M20,3V11.75L10,11.9V5.21L20,3M3,13L9,13.09V19.9L3,18.75V13M20,13.25V22L10,20.09V13.1L20,13.25Z"/>
  </svg>
)

const MacIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"/>
  </svg>
)

const LinuxIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16.2182,35.9c-3.1368,0-6.8982,1.496-7.2988,5.6766a.916.916,0,0,0,.9061,1.0025h11.97A.9.9,0,0,0,22.7,41.643C22.6175,39.8048,21.7865,35.9,16.2182,35.9Z"/>
    <path d="M18.0508,20.564c-1.35,1.0368-7.3687,7.51-4.3595,15.6667"/>
    <path d="M31.7818,35.9c3.1368,0,6.8982,1.496,7.2988,5.6766a.916.916,0,0,1-.9061,1.0025h-11.97A.9.9,0,0,1,25.3,41.643C25.3825,39.8048,26.2135,35.9,31.7818,35.9Z"/>
    <path d="M35.0148,36.4556c3.1848-2.8438,2.7468-7.5246,2.7468-8.7785,2.8935.82,5.0306,2.9709,5.5941,2.17,1.3744-1.9531-7.5193-7.5461-7.6918-10.8989C35.4951,15.6692,35.1706,5.4214,24,5.4214S12.5049,15.6692,12.3361,18.9484c-.1725,3.3528-9.0662,8.9458-7.6918,10.8989.5635.8007,2.7006-1.35,5.5941-2.17,0,1.2539-.438,5.9347,2.7468,8.7785"/>
    <path d="M29.2763,19.8324c1.9318,1.5032,8.0416,8.242,5.0324,16.3983"/>
    <path d="M24,24.8431l3.9479-4.2791c-.3858-1.0127-1.712-1.929-3.9479-1.929s-3.5621.9163-3.9479,1.929Z"/>
    <path d="M20.0521,20.564c-3.424.5063-3.9062-2.7247-3.9062-4.7019,0-2.7006,1.4467-4.4367,3.9062-4.4367S23.79,14.7529,23.79,16.3443A3.8486,3.8486,0,0,1,23.181,18.68"/>
    <path d="M27.7205,20.1334c.6751.0482,3.9538-.3892,3.9538-3.331s-1.76-3.7615-4.1232-3.7615a3.7861,3.7861,0,0,0-3.8164,2.6682"/>
    <path d="M22.7012,41.4815a6.8371,6.8371,0,0,0,2.6076,0"/>
    <circle fill="currentColor" cx="22.1579" cy="16.5888" r="0.75"/>
    <circle fill="currentColor" cx="25.5497" cy="16.5888" r="0.75"/>
  </svg>
)

const WebIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M16.36,14C16.44,13.3 16.5,12.66 16.5,12S16.44,10.7 16.36,10H19.74C19.9,10.64 20,11.31 20,12S19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.32 9.5,12.66 9.5,12S9.56,10.68 9.66,10H14.34C14.43,10.68 14.5,11.32 14.5,12S14.43,13.32 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12S4.1,10.64 4.26,10H7.64C7.56,10.7 7.5,11.34 7.5,12S7.56,13.3 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
  </svg>
)

/**
 * Helper function to get the appropriate platform icon
 * @param {string} platform - Platform name (case insensitive)
 * @param {string} className - CSS classes for the icon
 * @returns {JSX.Element} - Platform-specific icon or default phone icon
 */
export const getPlatformIcon = (platform, className = "w-8 h-8 text-text_secondary") => {
  if (!platform) {
    return <DevicePhoneMobileIcon className={className} />
  }

  const platformLower = platform.toLowerCase()

  switch (platformLower) {
    case 'ios':
    case 'iphone':
    case 'ipad':
      return <IOSIcon className={className} />
    
    case 'android':
      return <AndroidIcon className={className} />
    
    case 'windows':
    case 'win':
    case 'pc':
      return <WindowsIcon className={className} />
    
    case 'mac':
    case 'macos':
    case 'osx':
    case 'os x':
      return <MacIcon className={className} />
    
    case 'linux':
    case 'ubuntu':
    case 'debian':
    case 'fedora':
    case 'centos':
    case 'rhel':
      return <LinuxIcon className={className} />
    
    case 'web':
    case 'browser':
    case 'chrome':
    case 'firefox':
    case 'safari':
    case 'edge':
      return <WebIcon className={className} />
    
    default:
      return <DevicePhoneMobileIcon className={className} />
  }
}

export default {
  getPlatformIcon,
  IOSIcon,
  AndroidIcon,
  WindowsIcon,
  MacIcon,
  LinuxIcon,
  WebIcon
}